module.exports = __webpack_public_path__ + "static/scale-model-of-axe-throwing-tampa-in-tampa-florida-ead9a11c2d2c40e69d7dd4db762c62d4.png";